/* eslint-disable camelcase */
import classNames from "classnames";
import { useEffect, useState } from "react";
import { animated, useSpring } from "@react-spring/web";
import { useLocation, useParams } from "react-router-dom";

// Constants
import {
  TABBAR_NAVIGATION_ENUM,
  TABBAR_NAVIGATION_LIST,
} from "../../../constants/navigation/tabbar";
import { GET_POPUP_TYPES } from "../../../constants/popupConfig";

// Components
import TabbarItem from "../TabbarItem";

import "./styles.sass";

type TabbarProps = {
  notifications: TABBAR_NAVIGATION_ENUM[];
};

const hidePanelOnPages = ["/profile", "/profile/transactions"];

const Tabbar = ({ notifications = [] }: TabbarProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();
  const params = useParams();

  const [springs, api] = useSpring(() => ({
    from: { transform: "translateY(0%)" },
  }));

  useEffect(() => {
    let prevScrollY = window.scrollY;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (hidePanelOnPages.includes(location.pathname)) {
        if (currentScrollY > prevScrollY) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      } else {
        setIsVisible(true);
      }

      prevScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  useEffect(() => {
    api.start({
      transform: isVisible ? "translateY(0%)" : "translateY(120%)",
      config: { tension: 300, friction: 30 },
    });
  }, [isVisible, api]);

  const tabbarClass = classNames("Tabbar", {
    Tabbar__hidden:
      params.game ||
      (!location.search.includes(GET_POPUP_TYPES.popup.sideMenu) &&
        (location.search.includes(GET_POPUP_TYPES.page.profile) ||
          location.search.includes(GET_POPUP_TYPES.page.password) ||
          location.search.includes(GET_POPUP_TYPES.page.invite) ||
          location.pathname.includes("profile/transactions") ||
          location.pathname.includes("info/welcome-bonus") ||
          location.pathname.includes("tournament") ||
          location.pathname.includes("sportsbook"))) ||
      location.pathname.includes("personal-info"),
    Tabbar_dialog: location.search.includes(GET_POPUP_TYPES.popup.sideMenu),
  });

  return (
    <animated.div className={tabbarClass} style={{ ...springs }}>
      {TABBAR_NAVIGATION_LIST.map((item, index) => (
        <TabbarItem
          item={item}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          hasNotify={notifications.includes(item.id)}
        />
      ))}
    </animated.div>
  );
};
export default Tabbar;
